<template>
  <div class="treinamentos-page">
    <b-card no-body class="mb-3 header-card">
      <b-card-body class="d-flex align-items-center justify-content-between flex-wrap">
        <div>
          <h3 class="mb-1"><i class="fa fa-graduation-cap text-primary mr-2"></i>Treinamentos</h3>
          <p class="text-muted mb-0">Vídeos e materiais de capacitação para revendedoras</p>
        </div>
        <div>
          <b-button v-if="podeGerenciarCategorias" variant="outline-primary" size="sm" class="mr-2" @click="openCategoryModal()">
            <i class="fa fa-folder-plus"></i> Nova Categoria
          </b-button>
          <b-button v-if="podeGerenciarTreinamentos" variant="primary" size="sm" @click="openTrainingModal()">
            <i class="fa fa-plus"></i> Novo Treinamento
          </b-button>
        </div>
      </b-card-body>
    </b-card>

    <div v-if="!categorias.length" class="text-center text-muted py-5">
      <i class="fa fa-folder-open fa-3x mb-3"></i>
      <p>Nenhuma categoria cadastrada ainda.</p>
    </div>

    <b-tabs v-else v-model="tabAtiva" pills vertical nav-wrapper-class="treinamentos-tabs-nav" content-class="pl-md-4">
      <b-tab v-for="categoria in categorias" :key="categoria.id">
        <template #title>
          <div class="d-flex align-items-center justify-content-between">
            <span>{{ categoria.nome }}</span>
            <b-badge pill variant="light" class="ml-2">{{ treinamentosPorCategoria(categoria.id).length }}</b-badge>
          </div>
          <b-badge v-if="!categoria.ativo" variant="secondary" class="mt-1">inativa</b-badge>
        </template>

        <div class="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h5 class="mb-0">{{ categoria.nome }}</h5>
            <small class="text-muted">{{ categoria.descricao }}</small>
          </div>
          <b-button v-if="podeGerenciarCategorias" variant="outline-secondary" size="sm" @click="openCategoryModal(categoria)">
            <i class="fa fa-edit"></i> Editar Categoria
          </b-button>
        </div>

        <div v-if="treinamentosPorCategoria(categoria.id).length === 0" class="text-muted text-center py-4 border rounded">
          Nenhum treinamento cadastrado nesta categoria.
        </div>

        <b-row>
          <b-col md="4" v-for="treinamento in treinamentosPorCategoria(categoria.id)" :key="treinamento.id" class="mb-4">
            <b-card no-body class="h-100 training-card shadow-sm">
              <div class="training-thumb" @click="viewTraining(treinamento)">
                <img v-if="youtubeThumb(treinamento.youtube_url)" :src="youtubeThumb(treinamento.youtube_url)" alt="">
                <div v-else class="training-thumb-placeholder">
                  <i class="fa fa-file-alt fa-2x"></i>
                </div>
                <div v-if="treinamento.youtube_url" class="training-thumb-play">
                  <i class="fa fa-play-circle"></i>
                </div>
                <b-badge v-if="!treinamento.ativo" variant="secondary" class="training-thumb-badge">inativo</b-badge>
              </div>
              <b-card-body class="d-flex flex-column">
                <h6 class="mb-1 text-truncate" :title="treinamento.titulo">{{ treinamento.titulo }}</h6>
                <p class="text-muted small mb-2 training-desc">{{ treinamento.descricao }}</p>
                <div class="mb-2">
                  <b-badge v-for="classe in classesArray(treinamento.perm_classes)" :key="classe" variant="info" class="mr-1">
                    {{ classeLabel(classe) }}
                  </b-badge>
                  <b-badge v-if="!treinamento.perm_classes" variant="light" class="border">Todas as classes</b-badge>
                  <b-badge v-if="treinamento.anexos && treinamento.anexos.length" variant="light" class="border ml-1">
                    <i class="fa fa-paperclip"></i> {{ treinamento.anexos.length }}
                  </b-badge>
                </div>
                <div class="mt-auto d-flex justify-content-between align-items-center">
                  <b-button size="sm" variant="primary" @click="viewTraining(treinamento)">
                    <i class="fa fa-eye"></i> Visualizar
                  </b-button>
                  <div v-if="podeGerenciarTreinamentos">
                    <b-button size="sm" variant="outline-secondary" class="mr-1" @click="openTrainingModal(treinamento)"><i class="fa fa-edit"></i></b-button>
                    <b-button size="sm" variant="outline-danger" @click="deleteTraining(treinamento)"><i class="fas fa-trash-alt"></i></b-button>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <!-- Modal Categoria -->
    <b-modal v-model="categoryModal.open" :title="categoryModal.id ? 'Editar Categoria' : 'Nova Categoria'" @ok.prevent="saveCategory" ok-title="Salvar" cancel-title="Cancelar">
      <div class="form-group">
        <label>Nome</label>
        <input type="text" class="form-control" v-model="categoryModal.nome">
      </div>
      <div class="form-group">
        <label>Descrição</label>
        <textarea class="form-control" v-model="categoryModal.descricao"></textarea>
      </div>
      <div class="form-group form-check" v-if="categoryModal.id">
        <input type="checkbox" class="form-check-input" v-model="categoryModal.ativo" id="categoriaAtiva">
        <label class="form-check-label" for="categoriaAtiva">Ativa</label>
      </div>
    </b-modal>

    <!-- Modal Treinamento -->
    <b-modal v-model="trainingModal.open" size="lg" :title="trainingModal.id ? 'Editar Treinamento' : 'Novo Treinamento'" @ok.prevent="saveTraining" ok-title="Salvar" cancel-title="Cancelar">
      <div class="form-row">
        <div class="form-group col-md-8">
          <label>Título</label>
          <input type="text" class="form-control" v-model="trainingModal.titulo">
        </div>
        <div class="form-group col-md-4">
          <label>Categoria</label>
          <select class="form-control" v-model="trainingModal.training_category_id">
            <option v-for="categoria in categorias" :key="categoria.id" :value="categoria.id">{{ categoria.nome }}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label>Descrição</label>
        <textarea class="form-control" v-model="trainingModal.descricao" rows="2"></textarea>
      </div>
      <div class="form-group">
        <label>Link do YouTube</label>
        <input type="text" class="form-control" v-model="trainingModal.youtube_url" placeholder="https://www.youtube.com/watch?v=...">
        <div v-if="youtubeThumb(trainingModal.youtube_url)" class="mt-2">
          <img :src="youtubeThumb(trainingModal.youtube_url)" class="youtube-preview">
        </div>
      </div>
      <div class="form-group">
        <label>Classes de distribuidor permitidas <small class="text-muted">(deixe todas desmarcadas para liberar a todas as classes)</small></label>
        <b-form-checkbox-group v-model="trainingModal.classes" :options="CLASSES_DISTRIBUIDOR" stacked></b-form-checkbox-group>
      </div>
      <div class="form-group">
        <label>Anexos <small>(PDF, Word, Excel, PowerPoint ou imagem — máx. 22MB cada)</small></label>
        <b-form-file v-model="trainingModal.novosAnexos" multiple placeholder="Selecione os anexos..."></b-form-file>
      </div>
      <div v-if="trainingModal.anexos && trainingModal.anexos.length" class="mt-2">
        <div v-for="anexo in trainingModal.anexos" :key="anexo.id" class="d-flex justify-content-between align-items-center anexo-row">
          <span><i class="fa fa-paperclip"></i> {{ anexo.nome_original }}</span>
          <b-button variant="outline-danger" size="sm" @click="removeAnexo(anexo.id)"><i class="fa fa-times"></i></b-button>
        </div>
      </div>
    </b-modal>

    <!-- Modal Visualizar -->
    <b-modal v-model="viewModal.open" size="lg" :title="viewModal.titulo" hide-footer>
      <div v-if="viewModal.youtube_embed_url" class="embed-responsive embed-responsive-16by9 mb-3">
        <iframe class="embed-responsive-item" :src="viewModal.youtube_embed_url" allowfullscreen></iframe>
      </div>
      <p>{{ viewModal.descricao }}</p>
      <div class="mb-2">
        <b-badge v-for="classe in classesArray(viewModal.perm_classes)" :key="classe" variant="info" class="mr-1">{{ classeLabel(classe) }}</b-badge>
        <b-badge v-if="!viewModal.perm_classes" variant="light" class="border">Todas as classes</b-badge>
      </div>
      <div v-if="viewModal.anexos && viewModal.anexos.length">
        <h6>Anexos</h6>
        <ul class="list-unstyled">
          <li v-for="anexo in viewModal.anexos" :key="anexo.id" class="mb-1">
            <a :href="downloadUrl(viewModal.id, anexo.id)" target="_blank">
              <i class="fa fa-paperclip"></i> {{ anexo.nome_original }}
            </a>
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>

<script>
const CLASSES_DISTRIBUIDOR = [
  { value: 'A', text: 'Master (A)' },
  { value: 'G', text: 'Gestora (G)' },
  { value: 'S', text: 'Pedido Pessoal (S)' },
];

export default {
  props: {
    podeGerenciarTreinamentos: { type: Boolean, default: false },
    podeGerenciarCategorias: { type: Boolean, default: false },
  },
  data() {
    return {
      CLASSES_DISTRIBUIDOR,
      categorias: [],
      treinamentos: [],
      tabAtiva: 0,
      categoryModal: this.categoryModalDefaults(),
      trainingModal: this.trainingModalDefaults(),
      viewModal: { open: false },
    };
  },
  created() {
    this.loadCategorias();
    this.loadTreinamentos();
  },
  methods: {
    categoryModalDefaults() {
      return { open: false, id: null, nome: '', descricao: '', ativo: true };
    },
    trainingModalDefaults() {
      return {
        open: false, id: null, training_category_id: null, titulo: '', descricao: '',
        youtube_url: '', classes: [], novosAnexos: [], anexos: [],
      };
    },
    downloadUrl(trainingId, anexoId) {
      return `/adm/treinamentos/lista/${trainingId}/anexos/${anexoId}/download`;
    },
    treinamentosPorCategoria(categoriaId) {
      return this.treinamentos.filter((t) => t.training_category_id === categoriaId);
    },
    classesArray(permClasses) {
      return permClasses ? permClasses.split(',').map((c) => c.trim()).filter(Boolean) : [];
    },
    classeLabel(letra) {
      const classe = CLASSES_DISTRIBUIDOR.find((c) => c.value === letra);
      return classe ? classe.text : letra;
    },
    youtubeThumb(url) {
      if (!url) return null;
      const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null;
    },
    loadCategorias() {
      $(".loading").show();
      axios.get("/adm/treinamentos/categorias")
        .then((response) => { this.categorias = response.data; })
        .catch(() => this.$swal('Erro', 'Não foi possível carregar as categorias.', 'error'))
        .finally(() => $(".loading").hide());
    },
    loadTreinamentos() {
      $(".loading").show();
      axios.get("/adm/treinamentos/lista")
        .then((response) => { this.treinamentos = response.data; })
        .catch(() => this.$swal('Erro', 'Não foi possível carregar os treinamentos.', 'error'))
        .finally(() => $(".loading").hide());
    },
    openCategoryModal(categoria) {
      this.categoryModal = categoria
        ? { open: true, id: categoria.id, nome: categoria.nome, descricao: categoria.descricao, ativo: !!categoria.ativo }
        : this.categoryModalDefaults();
      this.categoryModal.open = true;
    },
    saveCategory() {
      const payload = {
        nome: this.categoryModal.nome,
        descricao: this.categoryModal.descricao,
        ativo: this.categoryModal.ativo,
      };
      const request = this.categoryModal.id
        ? axios.put(`/adm/treinamentos/categorias/${this.categoryModal.id}`, payload)
        : axios.post('/adm/treinamentos/categorias', payload);

      request
        .then(() => {
          this.categoryModal.open = false;
          this.loadCategorias();
        })
        .catch((error) => this.$swal('Erro', error.response?.data?.errors ? JSON.stringify(error.response.data.errors) : 'Não foi possível salvar a categoria.', 'error'));
    },
    openTrainingModal(treinamento) {
      if (treinamento) {
        axios.get(`/adm/treinamentos/lista/${treinamento.id}`).then((response) => {
          const t = response.data;
          this.trainingModal = {
            open: true, id: t.id, training_category_id: t.training_category_id,
            titulo: t.titulo, descricao: t.descricao, youtube_url: t.youtube_url,
            classes: this.classesArray(t.perm_classes),
            novosAnexos: [], anexos: t.anexos || [],
          };
        });
      } else {
        this.trainingModal = this.trainingModalDefaults();
        this.trainingModal.training_category_id = this.categorias[this.tabAtiva]?.id || this.categorias[0]?.id || null;
        this.trainingModal.open = true;
      }
    },
    saveTraining() {
      const formData = new FormData();
      formData.append('training_category_id', this.trainingModal.training_category_id);
      formData.append('titulo', this.trainingModal.titulo);
      formData.append('descricao', this.trainingModal.descricao || '');
      formData.append('youtube_url', this.trainingModal.youtube_url || '');
      formData.append('perm_classes', (this.trainingModal.classes || []).join(','));
      (this.trainingModal.novosAnexos || []).forEach((anexo) => formData.append('anexos[]', anexo));

      const url = this.trainingModal.id
        ? `/adm/treinamentos/lista/${this.trainingModal.id}`
        : '/adm/treinamentos/lista';

      axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(() => {
          this.trainingModal.open = false;
          this.loadTreinamentos();
        })
        .catch((error) => this.$swal('Erro', error.response?.data?.errors ? JSON.stringify(error.response.data.errors) : 'Não foi possível salvar o treinamento.', 'error'));
    },
    removeAnexo(anexoId) {
      axios.delete(`/adm/treinamentos/lista/${this.trainingModal.id}/anexos/${anexoId}`)
        .then(() => {
          this.trainingModal.anexos = this.trainingModal.anexos.filter((a) => a.id !== anexoId);
        });
    },
    viewTraining(treinamento) {
      axios.get(`/adm/treinamentos/lista/${treinamento.id}`).then((response) => {
        this.viewModal = { open: true, ...response.data };
      });
    },
    deleteTraining(treinamento) {
      this.$swal({
        title: 'Excluir treinamento?',
        text: treinamento.titulo,
        icon: 'warning',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          axios.delete(`/adm/treinamentos/lista/${treinamento.id}`).then(() => this.loadTreinamentos());
        }
      });
    },
  },
};
</script>

<style scoped>
.header-card {
  background: linear-gradient(135deg, #fff9f0 0%, #ffffff 100%);
  border: none;
}
.training-card {
  transition: transform .15s ease, box-shadow .15s ease;
  border: none;
  overflow: hidden;
}
.training-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.1) !important;
}
.training-thumb {
  position: relative;
  height: 160px;
  background: #f1f1f4;
  cursor: pointer;
  overflow: hidden;
}
.training-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.training-thumb-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b0b0b8;
}
.training-thumb-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 2.5rem;
  text-shadow: 0 1px 6px rgba(0,0,0,.5);
  opacity: .9;
  pointer-events: none;
}
.training-thumb-badge {
  position: absolute;
  top: 8px;
  right: 8px;
}
.training-desc {
  min-height: 2.5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.youtube-preview {
  max-width: 240px;
  border-radius: 6px;
}
.anexo-row {
  padding: 4px 0;
  border-bottom: 1px solid #eee;
}
::v-deep .treinamentos-tabs-nav {
  min-width: 220px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/treinamentos/Main.vue